import React from 'react';

type MinusIconProps = {
    className?: string;
};

export function MinusIcon({ className }: MinusIconProps) {
    return (
        <svg className={className} viewBox="0 0 16 1.43355" fill="none" aria-hidden="true">
            <path
                d="M0.649792 0.786517C1.1544 0.283371 1.84096 -0.000171797 2.55498 0C7.03729 0.0242726 11.5 0 16 0L15.3495 0.647721C14.8451 1.15063 14.1601 1.43355 13.4464 1.43355C9 1.43355 4.5 1.43355 0 1.43355L0.649792 0.786517Z"
                fill="currentColor"
            />
        </svg>
    );
}
